import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { TeamHeader } from './TeamHeader';
import { TeamGrid } from './TeamGrid';
import { teamMembers } from './teamData';

export default function Team() {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section className="bg-gray-50 pt-8 pb-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <TeamHeader />
        <div ref={ref}>
          <TeamGrid members={teamMembers} inView={inView} />
        </div>
      </div>
    </section>
  );
}